module.exports = "<h3 class=\"text-center font-weight-bold mt-5 pt-5\" style=\"color:red\"><strong>not-found-component works!</strong></h3>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/features/error404/error404.component.html
// module id = ./src/app/features/error404/error404.component.html
// module chunks = main